import React, { ReactNode } from 'react';
import styles from './assets/case-screen.module.scss';
import classNames from 'classnames';
import CasesGrid from './components/CasesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { ICaseNoConsent } from 'src/types/caseNoConsent';
import user from '../../../../../services/user-auth';
import UserRole from '../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<ICaseNoConsent>;
    districts: SelectObject[];
    vendors: SelectObject[];
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class OccasionNoConsentList extends React.Component<Props> {
    componentDidMount() {
        this.props.getProviders({
            page: 1,
        });
    }
    public render(): ReactNode {
        const { data, getData, districts, vendors, getDataCsv, providers } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.headingTitle, 'pageHeadingTitle')}>
                        Cases Without Telehealth Consent
                    </h2>
                </div>
                <div className={classNames(styles.list)}>
                    <CasesGrid
                        districts={districts}
                        providers={providers}
                        getDataCsv={getDataCsv}
                        vendors={vendors}
                        data={data}
                        getData={getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default OccasionNoConsentList;
